import React, { useState, useEffect, useRef } from 'react';
import Input from '../../../atoms/input/Input';
import { intl, formatMobileNumber, validatePhone } from '../../../utils/commonUtils';
import { getCurrentInputField, validateField } from '../validateFields';

const PhoneNumber = props => {
    const {
        label,
        name,
        handleInputChange,
        value,
        placeholder,
        dataTestId,
        inputAriaLabel,
        required,
        onValidate,
        requiredErrorMsg,
        formatErrorMsg,
        submit,
        setSubmit,
        onErrorAnalytics,
        disclaimerMsg,
        showErrorIcon,
        errorMessage,
        onFocus,
        errorId,
        inputRef
    } = props;

    const [errorMsg, setErrorMsg] = useState('');
    const inputRefPhoneNumber = useRef(null);

    useEffect(() => {
        const isValid = validateField(
            required,
            value,
            setErrorMsg,
            onValidate,
            validatePhone,
            submit,
            setSubmit,
            requiredErrorMsg,
            formatErrorMsg,
            onErrorAnalytics
        );
        getCurrentInputField(isValid, inputRef, inputRefPhoneNumber);
    }, [submit]);

    const validatePhoneFunc = text => {
        text.target.value = formatMobileNumber(text.target.value);
        handleInputChange(text);
        setErrorMsg('');
        onValidate(false);
    };

    return (
        <Input
            label={label}
            name={name}
            value={value}
            placeholder={placeholder}
            handleInputChange={validatePhoneFunc}
            dataTestId={dataTestId}
            inputAriaLabel={inputAriaLabel}
            errorMsg={errorMessage || errorMsg}
            disclaimerMsg={disclaimerMsg}
            showErrorIcon={showErrorIcon}
            handleInputFocus={onFocus}
            required={required}
            errorId={errorId}
            inputRef={inputRefPhoneNumber}
            autoComplete="tel"
            inputAriaRequired={required}
        />
    );
};

export default PhoneNumber;

PhoneNumber.defaultProps = {
    name: 'phoneNumber',
    label: intl.formatMessage({ id: 'checkout:your-details-phone-number' }),
    placeholder: intl.formatMessage({ id: 'checkout:your-details-phone-number-placeholder' }),
    requiredErrorMsg: intl.formatMessage({ id: 'common:required-input-error' }),
    formatErrorMsg: intl.formatMessage({ id: 'common:format-phone-error' }),
    showErrorIcon: false,
    onErrorAnalytics: () => {},
    onValidate: () => {},
    onFocus: () => {},
    errorId: ''
};
